module.exports = __webpack_public_path__ + "static/media/books.be06663f.jpg";